import { useEffect, useState } from 'react';
import { Table, Select, Button, message, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import './admin.css';

const fmt = (v) => Number(v || 0).toLocaleString('uz-UZ');
const STATUS = {
  pending: 'Kutilmoqda', confirmed: 'Tasdiqlangan', in_progress: 'Jarayonda',
  completed: 'Bajarilgan', cancelled: 'Bekor',
};

export default function AdminOrders() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState(null);

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (statusFilter) params.status = statusFilter;
      const r = await api.get('/admingov/orders', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => { setPage(1); fetchData(1); /* eslint-disable-next-line */ }, [statusFilter]);

  const changeStatus = async (id, status) => {
    try {
      await api.put(`/admingov/orders/${id}`, { status });
      message.success('Status yangilandi'); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/orders/${id}`);
      message.success("O'chirildi"); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Xizmat', dataIndex: 'service_name', render: v => v || '—' },
    { title: 'Biznes', dataIndex: 'business_name', render: v => v || '—' },
    { title: 'Mijoz', dataIndex: 'user_name', render: v => v || '—' },
    { title: 'Summa', dataIndex: 'summa', render: v => <b style={{ color: '#52c41a' }}>{fmt(v)} so'm</b> },
    {
      title: 'Sana',
      render: (_, r) => r.day && r.month && r.year ? `${String(r.day).padStart(2, '0')}.${String(r.month).padStart(2, '0')}.${r.year}` : '—',
    },
    {
      title: 'Status', dataIndex: 'status',
      render: (s, r) => (
        <Select size="small" value={s} onChange={v => changeStatus(r.id, v)} style={{ width: 140 }}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v, value: k }))} />
      ),
    },
    {
      title: 'Amal', width: 60, fixed: 'right',
      render: (_, r) => (
        <Popconfirm title="O'chirishni tasdiqlaysizmi?" okText="Ha" cancelText="Yo'q" onConfirm={() => handleDelete(r.id)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <div className="admin-toolbar">
        <Select placeholder="Status bo'yicha filtrlash" allowClear style={{ width: 220 }} value={statusFilter} onChange={setStatusFilter}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v, value: k }))} />
        <span style={{ marginLeft: 'auto', color: 'var(--a-muted)', fontSize: 13 }}>Jami: <b>{total}</b></span>
      </div>
      <div className="admin-table-card">
        <Table dataSource={data} columns={columns} rowKey="id" loading={loading} size="middle" scroll={{ x: 880 }}
          pagination={{ current: page, total, pageSize: 20, showSizeChanger: false,
            onChange: p => { setPage(p); fetchData(p); } }} />
      </div>
    </div>
  );
}
